<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
         x="0" y="0" viewBox="0 0 469.333 469.333" style="enable-background:new 0 0 512 512" xml:space="preserve"
         :width="size ? size : 512" :height="size ? size : 512"
         :class="[color]">
        <g xmlns="http://www.w3.org/2000/svg">
            <path d="M160,0h-21.333C132.771,0,128,4.771,128,10.667V128H10.667C4.771,128,0,132.771,0,138.667V160     c0,5.896,4.771,10.667,10.667,10.667H160c5.896,0,10.667-4.771,10.667-10.667V10.667C170.667,4.771,165.896,0,160,0z" fill="#000000" data-original="#000000"></path>
            <path d="M458.667,128H341.333V10.667C341.333,4.771,336.563,0,330.667,0h-21.333c-5.896,0-10.667,4.771-10.667,10.667V160     c0,5.896,4.771,10.667,10.667,10.667h149.333c5.896,0,10.667-4.771,10.667-10.667v-21.333     C469.333,132.771,464.563,128,458.667,128z" fill="#000000" data-original="#000000"></path>
            <path d="M458.667,298.667H309.333c-5.896,0-10.667,4.771-10.667,10.667v149.333c0,5.896,4.771,10.667,10.667,10.667h21.333     c5.896,0,10.667-4.771,10.667-10.667V341.333h117.333c5.896,0,10.667-4.771,10.667-10.667v-21.333     C469.333,303.437,464.563,298.667,458.667,298.667z" fill="#000000" data-original="#000000"></path>
            <path d="M160,298.667H10.667C4.771,298.667,0,303.437,0,309.333v21.333c0,5.896,4.771,10.667,10.667,10.667H128v117.333     c0,5.896,4.771,10.667,10.667,10.667H160c5.896,0,10.667-4.771,10.667-10.667V309.333     C170.667,303.437,165.896,298.667,160,298.667z" fill="#000000" data-original="#000000"></path>
        </g>
</svg>
</template>

<script>
export default {
    name: "IconFullscreenRestore",
    props: ['color', 'size'],
}
</script>

<style lang="scss" scoped>
path{fill:white}

.dark{
    path{
        fill:#4a4a5a;
    }
}
</style>
